"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Slider = _interopRequireDefault(require("./Slider"));

var _default = _Slider.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-slider/lib/index.js
// module id = 1027
// module chunks = 0